module.exports = __webpack_public_path__ + "img/63.a8ca6d6d.jpg";